// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-input-wrapper {
  pointer-events: none;
  grid-column: 7/span 2;
  width: 100%;
  justify-content: center;
  display: grid;
}
.color-input-wrapper > * {
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
}
.color-input-wrapper input {
  pointer-events: initial;
  cursor: pointer;
  width: 100%;
}
.color-input-wrapper .adjust-color-button {
  pointer-events: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
}
.color-input-wrapper .adjust-color-button .color-preview {
  width: 100%;
  height: 2px;
}
.color-input-wrapper .adjust-color-button label {
  font-weight: 300;
  color: rgb(110, 110, 110);
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ColorPicker/AdjustButton.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;EAEA,aAAA;AAAF;AAEE;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;AAGE;EACE,uBAAA;EACA,eAAA;EACA,WAAA;AADJ;AAIE;EACE,oBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAFJ;AAII;EACE,WAAA;EACA,WAAA;AAFN;AAKI;EACE,gBAAA;EACA,yBAAA;AAHN","sourcesContent":[".color-input-wrapper {\n  pointer-events: none;\n  grid-column: 7 / span 2;\n  width: 100%;\n  justify-content: center;\n\n  display: grid;\n\n  & > * {\n    grid-column-start: 1;\n    grid-column-end: 1;\n    grid-row-start: 1;\n    grid-row-end: 1;\n  }\n\n  input {\n    pointer-events: initial;\n    cursor: pointer;\n    width: 100%;\n  }\n\n  .adjust-color-button {\n    pointer-events: none;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    background-color: white;\n\n    .color-preview {\n      width: 100%;\n      height: 2px;\n    }\n\n    label {\n      font-weight: 300;\n      color: rgb(110, 110, 110);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
